import apiWorker from '../apiWorker'

const mxLogs = {
    findByContact : (contact_id) => apiWorker('get', `/v1/api/mx_logs/${contact_id}`),
}

export default mxLogs;
